<template>
  <div
    class="mt-8">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                color="#718EBF"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                color="#718EBF"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                color="#718EBF"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                color="#718EBF"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <v-select
                filled
                rounded
                dense

                color="#718EBF"
                placeholder="Contoh. 2023"

                hide-details

                :items="years"
                :item-color="set_color"

                v-model="filter.year"
                style="border-radius: 10px;">
              </v-select>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header">
              <div
                class="fs-20 font-weight-bold">
                {{ form.id === '' ? 'Tambahkan Kategori' : 'Mengubah Kategori' }}
              </div>

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon> -->

              <v-icon 
                @click="dialog.form = false; reset();"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="py-3 my-2 px-0">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Nama Kategori" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div 
                      class="fs-15 label-input">
                      <!-- <span class="red--text">*</span> -->
                      Nama Kategori
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
                      solo

                      color="#718EBF"
                      placeholder="Nama Kategori"

                      

                      v-model="form.name"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>


                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0">
              <v-spacer/>

              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>

              <!-- <v-btn 
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Hapus Data

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?

              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                rounded
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Ya, Hapus
              </v-btn>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pt-6">
            <v-card-title 
              class="d-flex align-center py-0 pb-4 text-right popup-header fs-18 font-weight-bold">
              
              Gambar Data

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light pa-6 pt-0 text-first line-text-second my-0 py-3" v-if="Object.keys(detail).length > 0">
              <v-row>
                <!-- <v-col>
                  <div>
                    <div>
                      Nama Sales
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.sales_name }}
                    </div>
                  </div>
                  <div>
                    <div>
                      Nama Customer
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.customer_name }}
                    </div>
                  </div>
    
                  <div>
                    <div>
                      Nama Toko
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.store_name }}
                    </div>
                  </div>

                  <div>
                    <div>
                      Tipe
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.type }}
                    </div>
                  </div>

                  <div>
                    <div>
                      Catatan
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.note === '' ? '-' : detail.note }}
                    </div>
                  </div>

                </v-col> -->
                
                <v-col>

                  <div v-if="selected.message === 'map'">
                    <div>
                      Lokasi Visit
                    </div>
                    <div class="fs-16 label-input">
                      <span v-if="detail.latitude === ''">
                        -
                      </span>
                      <a 
                        v-else
                      :href="`https://www.google.com/maps/search/?api=1&query=${detail.latitude},${detail.longitude}`"
                      style="color:#0000FF;text-align:left" 
                      target="_blank">
                        <iframe 
                          width="100%" 
                          height="170" 
                          frameborder="0" 
                          scrolling="no" 
                          marginheight="0" 
                          marginwidth="0" 
                          :src="`https://maps.google.com/maps?q=${detail.latitude},${detail.longitude}&hl=es&z=14&amp;output=embed`"
                          >
                        </iframe>
                      </a>
                    </div>
                  </div>

                  <div v-if="selected.message === 'image'">
                    <div class="fs-15 label-input mt-3 text-center justify-center">
                      <span v-if="selected_filter.image === ''">
                        -
                      </span>
                      <v-img
                        v-else
                        contain
                        width="500"
                        height="500"
                        :src="selected_filter.image" 
                        :alt="selected_filter.image"
                        class="text-center d-flex align-center mx-auto">
                      </v-img>
                    </div>
                  </div>

                </v-col>
              </v-row>



              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-6 pt-4">
              <v-spacer/>

              

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>



        <v-dialog v-model="dialog.bukti"
          @keydown.esc="dialog.bukti = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="">
            <v-card-title 
              class="d-flex align-center pb-4 text-right popup-header fs-18 font-weight-bold">
              
              Bukti Visit

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.bukti = false; dialog.fullscreen = false; selected.bukti = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.bukti = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
            class="body-1 font-weight-light text-first line-text-second my-0" v-if="Object.keys(detail).length > 0">
              <table style="width: auto;">
                <tr>
                  <td class="fs-13 py-1">
                    Nama Toko
                  </td>
                  <td style="width: 40px" class="fs-13 text-center">
                    : 
                  </td>
                  <td class="fs-13 text-left">
                    {{ detail.store_name }}
                  </td>
                </tr>
                <tr>
                  <td class="fs-13 py-1">
                    Checkin
                  </td>
                  <td style="width: 40px" class="fs-13 text-center">
                    : 
                  </td>
                  <td class="fs-13 text-left">
                    {{ detail.checkin_datetime | timeFull }}
                  </td>
                </tr>
                <tr>
                  <td class="fs-13 py-1">
                    Checkout
                  </td>
                  <td style="width: 40px" class="fs-13 text-center">
                    : 
                  </td>
                  <td class="fs-13 text-left">
                    <span v-if="detail.checkout_datetime !== null">{{ detail.checkout_datetime | timeFull }}</span> <span v-else>-</span>
                  </td>
                </tr>
                <tr>
                  <td class="fs-13 py-1">
                    Lama Waktu Visit
                  </td>
                  <td style="width: 40px" class="fs-13 text-center">
                    : 
                  </td>
                  <td class="fs-13 text-left">
                    <span v-if="detail.checkout_datetime !== null">{{ toMoment(detail.checkin_datetime, detail.checkout_datetime) }}</span> <span v-else>-</span>
                  </td>
                </tr>
                <!-- <tr>
                  <td class="py-1">
                    Type
                  </td>
                  <td style="width: 40px" class="text-center">
                    : 
                  </td>
                  <td class="text-left text-capitalize">
                    {{ detail.type }}
                  </td>
                </tr>
                <tr>
                  <td class="py-1">
                    Catatan
                  </td>
                  <td style="width: 40px" class="text-center">
                    : 
                  </td>
                  <td class="text-left">
                    {{ detail.catatan === '' ? '-' : detail.catatan }}
                  </td>
                </tr> -->
              </table>

              <div class="mt-2">
                <img 
                  :src="detail.foto_bukti !== '' ? detail.foto_bukti : require('@/assets/image/image_default.png')"
                  alt="Mitra Warung" 
                  style="width: 100%; height: 100%; border: 2px dashed #e0e0e0; border-radius: 8px !important;" />


                <img 
                  :src="detail.foto_bukti_2 !== '' ? detail.foto_bukti_2 : require('@/assets/image/image_default.png')"
                  alt="Mitra Warung" 
                  class="my-1"
                  v-if="detail.foto_bukti_2 !== ''"
                  style="width: 100%; height: 100%; border: 2px dashed #e0e0e0; border-radius: 8px !important;" />


                <img 
                  :src="detail.foto_bukti_3 !== '' ? detail.foto_bukti_3 : require('@/assets/image/image_default.png')"
                  alt="Mitra Warung" 
                  v-if="detail.foto_bukti_3 !== ''"
                  style="width: 100%; height: 100%; border: 2px dashed #e0e0e0; border-radius: 8px !important;" />
                <!-- <v-avatar
                  size="100%"
                  tile
                  @click="selected.message = 'image'; dialog.detail = true; detail = selected"
                  style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                  <v-img 
                    contain
                    width="100%"
                    height="100%"
                    alt="Mitra Warung" 
                    :src="selected.foto_bukti !== '' ? selected.foto_bukti : require('@/assets/image/image_default.png')"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          color="#718EBF">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar> -->
              </div>

              <div class="mt-2">
                <div class="black--text">
                  Lokasi Visit
                </div>
                <div class="fs-16 label-input">
                  <span v-if="detail.latitude === ''">
                    -
                  </span>
                  <a 
                    v-else
                  :href="`https://www.google.com/maps/search/?api=1&query=${detail.latitude},${detail.longitude}`"
                  style="color:#0000FF;text-align:left" 
                  target="_blank">
                    <iframe 
                      width="100%" 
                      height="170" 
                      frameborder="0" 
                      scrolling="no" 
                      marginheight="0" 
                      marginwidth="0" 
                      :src="`https://maps.google.com/maps?q=${detail.latitude},${detail.longitude}&hl=es&z=14&amp;output=embed`"
                      >
                    </iframe>
                  </a>
                </div>
              </div>

            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="dialog.bukti = false; dialog.fullscreen = false;"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>

          <!-- <div class="d-flex mb-3">
            <div>
              <div class="fs-22 color-dark-blue font-weight-medium">
                Visit
              </div>
            </div>
            <v-spacer />
            <div>
              <v-btn
                color="#1814F3"
                width="195"
                height="50"
                elevation="0"
                style="border-radius: 9px;"
                @click="dialog.form = true; reset();"
                class="fs-16 white--text text-capitalize">
                <v-icon size="18" class="mr-1 pt-1">mdi-plus</v-icon>
                Tambah Kategori
              </v-btn>
            </div>
          </div> -->
          <v-card 
            flat
            class="ma-4 mt-0 box-shadow pb-5"
            style="border-radius: 10px;">

            <v-row
              class="pa-4 py-0">
              <v-col
                cols="12"
                md="7">
                <span
                  class="fs-16 black--text ml-2"
                  style="font-weight: 600;">
                  Laporan Visit Detail
                </span>
                <!-- <div
                  class="body-2">
                  Perbandingan SP2D 

                  <span v-if="filter.year !== '' && filter.year !== null">
                    tahun <strong class="black--text">{{ filter.year }}</strong>
                  </span>

                  <span v-if="filter.month !== '' && filter.month !== null">
                    di bulan <strong class="black--text">{{ filter.month_text }}</strong>
                  </span>
                </div> -->
              </v-col>
              <v-col
                cols="12"
                md="12"
                class="d-flex align-center">
                <!-- <v-btn
                  color="#4B4B4B"
                  elevation="0"
                  :disabled="process.load"
                  @click="dialog.form = true; reset();"
                  class="body-2 white--text text-capitalize d-flex align-center ml-0"
                  style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                  <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                  
                  <span
                    class="ml-2">
                    Tambah
                  </span>
                </v-btn> -->
                <!-- <div v-if="$store.state.user.category_user_title !== 'Supervisor'">
                  <v-autocomplete
                    v-model="filterDataSupervisor"
                    :items="supervisor"
                    item-text="name"
                    item-value="id"
                    clearable
                    @click:clear="filterDataSupervisor = ''; changeFilterSupervisor();"
                    hide-details
                    @change="changeFilterSupervisor()"
                    filled
                    rounded
                    dense
                    class="fs-12 little-placeholder mr-3"

                    color="#718EBF"
                    placeholder="Nama Supervisor"

                    
                    :item-color="set_color"
                    style="border-radius: 6px; background: #d9e8ff9c !important; width: 220px">
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                      </template>
                    </template>

                  </v-autocomplete>
                </div> -->
                <v-autocomplete
                  v-model="filter.sales"
                  :items="sales"
                  item-text="name"
                  item-value="id"
                  clearable
                  @click:clear="filter.sales = ''; fetch();"
                  hide-details
                  @change="fetch()"
                  filled
                  rounded
                  dense
                  class="fs-12 little-placeholder"

                  color="#718EBF"
                  placeholder="Nama Sales"

                  
                  :item-color="set_color"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 220px">
                  <!-- <template v-slot:selection="{ item }">
                    <v-chip
                      v-if="item"
                      label
                      close
                      @click:close="filterDataSales = null">
                      {{ item.name }}
                    </v-chip>
                  </template> -->
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                    </template>
                  </template>

                </v-autocomplete>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.date"
                      :color="set_color"
                      placeholder="Pilihan tanggal"
                      hide-details
                      readonly
                      filled
                      rounded
                      clearable
                      @click:clear="filter.date = ''; fetch();"
                      dense
                      v-bind="attrs"
                      v-on="on"
                      class="fs-12 little-placeholder ml-3"
                      style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 300px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filter.date"
                    no-title
                    scrollable                    
                    @input="toInput()"

                  >
                    <!-- <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu2 = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu2.save(filter.date); fetch()"
                    >
                      OK
                    </v-btn> -->
                  </v-date-picker>
                </v-menu>
                <!-- <v-text-field
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line

                  hide-details
                  :color="set_color"
                  placeholder="Cari data yang Anda butuhkan . . ."
                  append-icon="mdi-magnify"
                  clearable

                  v-model="search"
                  class="ml-3 fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                </v-text-field> -->

                <!-- FREEZE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div> -->

                <!-- HIDE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div> -->
              </v-col>
            </v-row>

            <!-- <v-divider 
              class="mb-4"
              style="border-top: 1px solid #EBEBEB;"/> -->

              
            <v-card 
              flat
              class="mt-0 mx-5"
              v-if="filter.date !== '' && filter.date !== null && filter.sales !== '' && filter.sales !== null">

              <v-card-text
              v-if="list.length === 0 && !process.load"
              class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                <div class="text-center">
                  <v-img 
                    class="mx-auto"
                    contain
                    alt="vuetify"
                    :width="90"
                    :height="90"
                    :src="require('@/assets/image/empty.png')">
                    <!-- <template v-slot:placeholder>
                      <v-row
                        class=" "
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template> -->
                  </v-img>
                  <div class="mt-3 fs-16">
                    Belum Ada Data
                  </div>
                </div>
              </v-card-text>

              <div v-if="!process.load && list.length > 0">
                <v-tabs
                  v-model="tabs"
                  dense
                  background-color="transparent"
                  slider-size="5"
                  v-on:change="tabs === 1 ? fetchNotVisited() : fetch()"
                  color="#1814F3">
                  <v-tab
                    v-for="(item, index) in tab"
                    :key="index">
                    <span
                      class="body-2 font-weight-medium text-capitalize">
                      {{ item.title }}
                    </span>
                  </v-tab>
                </v-tabs>
                <v-divider style="border-color: #EBEEF2;"></v-divider>
              </div>
              
              
              <!-- :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '148px'})`" -->
              <div class="pa-0" v-if="tabs === 0 && !process.load">
                <div v-if="!process.load && list.length > 0">
                  <v-card flat style="border-radius: 8px; border: 1px solid #E7E7E7;">
                    <v-card-text class="black--text">
                      <div class="d-flex align-center font_weight_600 px-1" style="width: 100%">
                        <div>
                          {{ list[0].sales_name }}
                        </div>
                        <div class="ml-auto">
                          {{ filter.date | date }}
                        </div>
                      </div>

                      <v-row>
                        <v-col cols="12" md="3">
                          <div class="d-flex align-center px-1">
                            <div>
                              Jam Checkin
                            </div>
                            <div class="pl-2">
                              : {{ list[0].presensi_start_datetime | timeFull }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="3">
                          <div class="d-flex align-center px-1 ">
                            <div>
                              Jam Checkout
                            </div>
                            <div class="pl-2">
                              : {{ list[0].presensi_end_datetime | timeFull }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6">
                          <div class="d-flex align-center px-1 " style="justify-content: end;">
                            <div>
                              Total Jam kerja
                            </div>
                            <div class="pl-2">
                              : {{ toMoment(list[0].presensi_start_datetime, list[0].presensi_end_datetime) }}
                            </div>
                          </div>
                        </v-col>
                      </v-row>

                      <v-divider class="mt-2 mb-2" style="border-top: 1px solid #EBEBEB;"/>
                      <div class="view">
                        <div :class="process.load || list.length === 0 ? '' : 'wrapper-detail-jadwal-visit'">
                          <table style="border-radius: 10px; width: 100%;" class="table">
                            <tr>
                              <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                              <th class="sticky-col second-col-laporan-detail-visit" style="z-index: 2; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                Nama Toko
                              </th>
                              <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                Kode Outlet
                                <span v-if="sortBy === 'customer_code'">
                                  <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                                  <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                                </span>
                              </th>
                              <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                Checkin
                              </th>
                              <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                Checkout
                              </th>
                              <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                Lama Visit
                              </th>
                              <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                Lama Perjalanan
                              </th>
                              <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                Type
                              </th>
                              <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                Order
                              </th>
                              <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                Catatan
                              </th>
                              <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                Bukti
                              </th>
                              <!-- <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;"></th> -->
                              <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Realisasi</th>
                              <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                            </tr>
                            <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                              <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 80px; min-width: 80px; max-width: 80px; padding: 8px 12px; text-align: center;">
                                {{index + 1}}
                              </td>
                              <td class="sticky-col second-col-laporan-detail-visit" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; text-align: left; text-wrap: auto;">
                                <a target="_blank" :href="`/customer/data/detail/${item.customer_id}`">
                                  {{ item.store_name }}
                                </a>
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                                {{ item.customer_code }}
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                                {{ item.checkin_datetime | timeFull }}
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px;min-width: 200px; width: 200px; text-align: left;">
                                <span v-if="item.checkout_datetime !== null">{{ item.checkout_datetime | timeFull }}</span> <span v-else>-</span>
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px;min-width: 200px; width: 200px; text-align: left;">
                                <span v-if="item.checkout_datetime !== null">{{ toMoment(item.checkin_datetime, item.checkout_datetime) }}</span> <span v-else>-</span>
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px;min-width: 200px; width: 200px; text-align: left;">
                                <span v-if="index !== 0">
                                  {{ toMoment(list[index-1].checkout_datetime, list[index].checkin_datetime) }}
                                </span>
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px;min-width: 200px; width: 200px; text-align: left;">
                                <span class="text-left text-capitalize">
                                  {{ item.type }}
                                </span>
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px;min-width: 100px; width: 100px; text-align: left;">
                                {{ item.total_order*1 | number }}
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px;min-width: 200px; width: 200px; text-align: left;">
                                {{ item.note === '' ? '-' : item.note }}
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 80px; min-width: 80px; max-width: 80px; padding: 8px 12px; text-align: center;">
                                <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="dialog.bukti = true; detail = item;"
                                      min-width="28"
                                      small
                                      rounded
                                      color="green"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon small>mdi-information-outline</v-icon>
                                    </v-btn>
                                  </template>
    
                                  <span>Bukti Visit</span>
                                </v-tooltip>
                              </td>
                              
                              <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                              <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                                {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                                {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                              </td> -->
                            </tr>
                          </table>
                        </div>
                      </div>

                    </v-card-text>
                  </v-card>
                </div>

                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" 
                  style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>

                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>
                
                <!-- <pagination v-if="!process.load && pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination" :display="paginationList"/> -->
                  
              </div>

              <div v-if="tabs === 1 && !process.load && list.length > 0">
                <v-card flat style="border-radius: 8px; border: 1px solid #E7E7E7;">
                  <v-card-text class="black--text">
                    <div class="d-flex align-center font_weight_600 px-1" style="width: 100%">
                      <div>
                        {{ list[0].sales_name }}
                      </div>
                      <div class="ml-auto">
                        {{ filter.date | date }}
                      </div>
                    </div>

                    <v-row>
                      <v-col cols="12" md="6">
                        <div class="d-flex align-center px-1">
                          <div>
                            Total Toko Tidak Dikunjungi
                          </div>
                          <div class="pl-2">
                            : {{ data_tidak_tervisit.length | number }} Toko
                          </div>
                        </div>
                      </v-col>
                    </v-row>

                    <v-divider class="mt-2 mb-2" style="border-top: 1px solid #EBEBEB;"/>
                    <div class="view">
                      <div :class="process.load || data_tidak_tervisit.length === 0 ? '' : 'wrapper-detail-jadwal-visit'">
                        <table style="border-radius: 10px; width: 100%;" class="table">
                          <tr>
                            <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">No</th>
                            <th class="sticky-col second-col-laporan-detail-visit" style="z-index: 2; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Nama Toko
                            </th>
                            <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Kode Outlet
                            </th>
                            <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Tipe Toko
                            </th>
                            <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Nama Customer
                            </th>
                            <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              PIC Toko
                            </th>
                            <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              No. HP
                            </th>
                            <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Alamat
                            </th>
                            <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Kelurahan
                            </th>
                            <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Kecamatan
                            </th>
                            <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Kota/Kabupaten
                            </th>
                            <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Provinsi
                            </th>
                            <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Catatan
                            </th>
                            <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Minggu
                            </th>
                          </tr>
                          <tr v-for="(item, index) in data_tidak_tervisit" :key="index" @click="selected.row = 'not-visit-' + index" :class="selected.row === 'not-visit-' + index ? 'selected' : ''">
                            <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 80px; min-width: 80px; max-width: 80px; padding: 8px 12px; text-align: center;">
                              {{ index + 1 }}
                            </td>
                            <td class="sticky-col second-col-laporan-detail-visit" style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; text-align: left; text-wrap: auto;">
                              <a target="_blank" :href="`/customer/data/detail/${item.customer_id}`">
                                {{ item.store_name }}
                              </a>
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                              {{ item.customer_code }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 200px; width: 200px; text-align: left;">
                              {{ item.store_type }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 150px; width: 150px; text-align: left;">
                              {{ item.customer }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 150px; width: 150px; text-align: left;">
                              {{ item.store_pic_name || '-' }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 150px; width: 150px; text-align: left;">
                              {{ item.store_pic_mobilephone || '-' }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 250px; width: 250px; text-align: left;">
                              {{ item.store_address }}{{ item.store_address_detail ? ', ' + item.store_address_detail : '' }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 150px; width: 150px; text-align: left;">
                              {{ item.store_village_name || '-' }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 150px; width: 150px; text-align: left;">
                              {{ item.store_subdistrict_name || '-' }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 200px; width: 200px; text-align: left;">
                              {{ item.store_city_name || '-' }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 150px; width: 150px; text-align: left;">
                              {{ item.store_province_name || '-' }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 200px; width: 200px; text-align: left;">
                              {{ item.store_notes || '-' }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 100px; width: 100px; text-align: center;">
                              {{ item.minggu || '-' }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>

                  </v-card-text>
                </v-card>
              </div>

              <div v-if="tabs === 2 && !process.load && list.length > 0">
                <gmap-map
                  :center="{ lat: (list[0].latitude*1), lng: (list[0].longitude*1) }"
                  :zoom="14"
                  style="width: 100%; height: 600px">
                  <!-- <gmap-info-window 
                      @closeclick="window_open=false" 
                      :opened="window_open" 
                      :position="selected.position"
                      :options="{
          pixelOffset: {
            width: 0,
            height: -35
          }
        }"
                  >
                  {{ selected.label }}
                  </gmap-info-window>   -->
                  <gmap-info-window 
                    @closeclick="window_open=false" 
                    :opened="window_open" 
                    :position="selected.position"
                    :options="{
                      pixelOffset: {
                        width: 0,
                        height: -35
                      }
                    }">
                    <v-card
                      class="mx-auto"
                      max-width="400"
                      flat>
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <div class="fs-15 mb-2 font_weight_600">
                            {{ selected.label }}
                          </div>

                          <v-divider class="mt-2 mb-2" style="border-top: 1px solid #EBEBEB;"/>

                          <div style="height: 350px; overflow-y: auto;">
                            <!-- Info untuk toko yang sudah dikunjungi -->
                            <table style="width: auto;" v-if="selected.marker_type === 'visit'">
                                <tr>
                                  <td class="py-1">
                                    Checkin
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left">
                                    {{ selected.checkin | timeFull }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1">
                                    Checkout
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left">
                                    <span v-if="selected.checkout !== null">{{ selected.checkout | timeFull }}</span> <span v-else>-</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1">
                                    Lama Waktu Visit
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left">
                                    <span v-if="selected.checkout !== null">{{ toMoment(selected.checkin, selected.checkout) }}</span> <span v-else>-</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1">
                                    Type
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left text-capitalize">
                                    {{ selected.type }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1">
                                    Catatan
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left">
                                    {{ selected.catatan === '' ? '-' : selected.catatan }}
                                  </td>
                                </tr>
                              </table>

                            <!-- Info untuk toko yang tidak dikunjungi -->
                            <table style="width: auto;" v-if="selected.marker_type === 'not-visit'">
                                <tr>
                                  <td class="py-1">
                                    Status
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left">
                                    <v-chip small color="red" text-color="white">Tidak Dikunjungi</v-chip>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1">
                                    Kode Outlet
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left">
                                    {{ selected.customer_code || '-' }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1">
                                    Tipe Toko
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left">
                                    {{ selected.store_type || '-' }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1">
                                    Customer
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left">
                                    {{ selected.customer || '-' }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1">
                                    Alamat
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left">
                                    {{ selected.store_address }}{{ selected.store_address_detail ? ', ' + selected.store_address_detail : '' }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1">
                                    Catatan
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left">
                                    {{ selected.catatan === '' ? '-' : selected.catatan }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1">
                                    Minggu
                                  </td>
                                  <td style="width: 40px" class="text-center">
                                    : 
                                  </td>
                                  <td class="text-left">
                                    {{ selected.minggu || '-' }}
                                  </td>
                                </tr>
                              </table>

                            <div class="mt-2" v-if="selected.marker_type === 'visit'">
                              <img 
                                :src="selected.foto_bukti !== '' ? selected.foto_bukti : require('@/assets/image/image_default.png')"
                                alt="Mitra Warung" 
                                @click="selected.message = 'image'; dialog.detail = true; detail = selected; selected_filter.image = selected.foto_bukti"
                                style="width: 400px; height: 100%; border: 2px dashed #e0e0e0; border-radius: 8px !important;" />


                              <img 
                                :src="selected.foto_bukti_2 !== '' ? selected.foto_bukti_2 : require('@/assets/image/image_default.png')"
                                alt="Mitra Warung" 
                                class="my-1"
                                v-if="selected.foto_bukti_2 !== ''"
                                @click="selected.message = 'image'; dialog.detail = true; detail = selected; selected_filter.image = selected.foto_bukti_2"
                                style="width: 400px; height: 100%; border: 2px dashed #e0e0e0; border-radius: 8px !important;" />


                              <img 
                                :src="selected.foto_bukti_3 !== '' ? selected.foto_bukti_3 : require('@/assets/image/image_default.png')"
                                alt="Mitra Warung" 
                                v-if="selected.foto_bukti_3 !== ''"
                                @click="selected.message = 'image'; dialog.detail = true; detail = selected; selected_filter.image = selected.foto_bukti_3"
                                style="width: 400px; height: 100%; border: 2px dashed #e0e0e0; border-radius: 8px !important;" />
                              <!-- <v-avatar
                                size="100%"
                                tile
                                @click="selected.message = 'image'; dialog.detail = true; detail = selected"
                                style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                <v-img 
                                  contain
                                  width="100%"
                                  height="100%"
                                  alt="Mitra Warung" 
                                  :src="selected.foto_bukti !== '' ? selected.foto_bukti : require('@/assets/image/image_default.png')"
                                  class="ma-auto">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        size="20"
                                        indeterminate 
                                        color="#718EBF">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-avatar> -->
                            </div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </gmap-info-window>    
                  <gmap-marker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :clickable="true"
                    :label="{text: m.label, color: 'white', fontSize: '12px', fontWeight: 'bold'}"
                    :icon="getMarkerIcon(m.type)"
                    @click="toggleInfo(m, index)">
                  </gmap-marker>
                </gmap-map>

              </div>


              <!-- <pagination v-if="pagination.total_data > 0"
                @changePage="fetch($event)" 
                @reloadPage="fetch($event)" 
                :model="pagination"/> -->
            </v-card>

            <v-card 
              flat
              class="mt-0 mx-5"
              v-else>
              <v-card-text
                class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                <div class="text-center">
                  <v-img 
                    class="mx-auto"
                    contain
                    alt="vuetify"
                    :width="90"
                    :height="90"
                    :src="require('@/assets/image/empty.png')">
                    <!-- <template v-slot:placeholder>
                      <v-row
                        class=" "
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template> -->
                  </v-img>
                  <div class="mt-3 fs-16">
                    Pilih Tanggal dan Sales
                  </div>
                </div>
              </v-card-text>
            </v-card>
            
          </v-card>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        filterDate: '',

        sortBy: 'id',
        sortDesc: '-',

        menu2: false,
        center: {lat: -7.703889,
              lng: 110.601667},
            markers: [
                {
                    label: "A",
                    position: {lat: -7.703889,
              lng: 110.601667}
                }, 
                // {
                //     label: "B",
                //     position: {lat: 11.0, lng: 11.0}
                // }
            ],
        selected: {
          position: {},
          label: '',
          marker_type: '',
          checkin: '',
          checkout: '',
          foto_bukti: '',
          foto_bukti_2: '',
          foto_bukti_3: '',
          catatan: '',
          type: '',
          customer_code: '',
          store_type: '',
          customer: '',
          store_address: '',
          store_address_detail: '',
          minggu: '',
          freeze: [],
          delete: [],
          row: [],
          message: '',
          index: '',
        },


        tabs: 0,
        tab: [
          { title: 'Informasi' },
          { title: 'Tidak Dikunjungi' },
          { title: 'Map' }
        ],

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          form: false,
          delete: false,
          detail: false,
          bukti: false
        },
        
        search: '',
        detail: {},

        filterDataSupervisor: '',

        filter: {
          year: new Date().getFullYear(),
          sales: '',
          date: ''
        },

        sales: [],
        salesAll: [],

        data_tidak_tervisit: [],

        // selected: {
        //   freeze: [],
        //   delete: [],
        //   row: [],
        //   message: '',
        //   index: '',
        // },

        selected_filter: {
          year: new Date().getFullYear(),
          sales: '',
          date: [],
          image: ''
        },

        type: [
          { title: 'Kategori', id: 'Kategori' },
          { title: 'Kantor', id: 'kantor'}
        ],

        form: {
          id: '',
          name: '',
          par_id: '0'
        },
        window_open: false,

        options: {},
        headers: [],
        list: [],
        supervisor: [],
        pagination: {},
        paginationList: {},

        lastIndex: 0,
        limit: 50,

        process: {
          load: false,

          delete: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      this.fetchSales()
      this.fetchSupervisor()
      this.fetch()
    },
    methods: {
      toggleInfo (m) {
    this.selected.position = m.position
    this.selected.label = m.name
    this.selected.marker_type = m.type // 'visit' atau 'not-visit'
    this.selected.checkin = m.item.checkin_datetime
    this.selected.checkout = m.item.checkout_datetime
    this.selected.foto_bukti = m.item.foto_bukti
    this.selected.foto_bukti_2 = m.item.foto_bukti_2
    this.selected.foto_bukti_3 = m.item.foto_bukti_3
    this.selected.catatan = m.item.note
    this.selected.type = m.item.type
    this.selected.index = m.index
    // Data tambahan untuk toko tidak dikunjungi
    this.selected.customer_code = m.item.customer_code || ''
    this.selected.store_type = m.item.store_type || ''
    this.selected.customer = m.item.customer || ''
    this.selected.store_address = m.item.store_address || ''
    this.selected.store_address_detail = m.item.store_address_detail || ''
    this.selected.minggu = m.item.minggu || ''
            this.window_open = this.window_open ? false : true
            setTimeout(() => {
                this.window_open = true
            }, 200)
        },

      getMarkerIcon(type) {
        // Menggunakan pin default Google Maps dengan warna berbeda
        if (type === 'visit') {
          // Pin merah untuk toko yang sudah dikunjungi (default Google Maps)
          return undefined // undefined = gunakan default merah
        } else if (type === 'not-visit') {
          // Pin abu-abu untuk toko yang tidak dikunjungi
          return {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
              <svg xmlns="http://www.w3.org/2000/svg" width="27" height="43" viewBox="0 0 27 43">
                <path fill="#78909C" stroke="#FFFFFF" stroke-width="2" d="M12.5 0C5.596 0 0 5.596 0 12.5c0 1.866.414 3.638 1.146 5.241C2.36 20.5 12.5 40 12.5 40s10.14-19.5 11.354-22.259A12.387 12.387 0 0025 12.5C25 5.596 19.404 0 12.5 0z"/>
              </svg>
            `),
            scaledSize: { width: 27, height: 43 },
            labelOrigin: { x: 13, y: 13 }
          }
        }
        
        // Default Google Maps merah
        return undefined
      },

      toMoment (start, end) {
        var date1 = new Date(start);
        var date2 = new Date(end);

        var diff = date2.getTime() - date1.getTime();

        var msec = diff;
        var hh = Math.floor(msec / 1000 / 60 / 60);
        msec -= hh * 1000 * 60 * 60;
        var mm = Math.floor(msec / 1000 / 60);
        msec -= mm * 1000 * 60;
        var ss = Math.floor(msec / 1000);
        msec -= ss * 1000;
        return `${hh} Jam ${mm} Menit ${ss} Detik`;
        
      },
      toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetch()
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetch()
      },
      toInput() {
        this.menu2 = this.filter.date.length > 1 ? false : true
        if (this.filter.date.length > 1) {
          this.fetch()
        }
      },
      async fetchSales () {
        // this.process.load = true

        let params = {
          'category_user_id[eq]': '8',
          limit: 1000000,
          spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : '',
          is_active: 'Aktif'
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.sales = res.results.data
            this.salesAll = res.results.data
            if(this.filterDataSupervisor !== '' && this.filterDataSupervisor !== null && this.filterDataSupervisor !== undefined) {
              this.sales = this.salesAll.filter(sales => sales.spv_id === this.filterDataSupervisor)
            }
          }
          this.process.load = false
        })
      },
      async fetchSupervisor () {
        this.process.load = true

        let params = {
          'category_user_id[eq]': '5',
          is_active: 'Aktif',
          limit: 1000000,
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.supervisor = res.results.data
            
          }
          this.process.load = false
        })
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },

      changeFilterSupervisor (e) {
        this.filter.sales = ''
        this.sales = this.filterDataSupervisor !== '' && this.filterDataSupervisor !== null && this.filterDataSupervisor !== undefined ? this.salesAll.filter(sales => sales.spv_id === this.filterDataSupervisor) : this.salesAll
        this.fetch()
      },

      async fetch (pagination = { row: 50, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination


        let params = {
          datetime: this.filterDate,
          limit: 1000000000000,
          sort: `${this.sortDesc}${this.sortBy}`,
          sales_id: this.filter.sales,
          date: this.filter.date,
          // spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : this.filterDataSupervisor,
          // sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        }

        this.selected.row = []

        // admin/services/data
        
        await get(`admin/visit/detail`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.headers = [
              {
                text: '',
                width: '120px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'start',
                format: 'action'
              },
              {
                text: 'No',
                width: '80',
                value: 'index',
                freeze: false,
                hide: false
              },
              {
                text: 'Tanggal',
                width: '200px',
                value: 'datetime',
                freeze: true,
                hide: false,
                format: 'datetime'
              },
              {
                text: 'Nama Sales',
                width: '300px',
                value: 'sales_name',
                freeze: true,
                hide: false
              },
              {
                text: 'Nama Customer',
                width: '200px',
                value: 'customer_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Toko',
                width: '200px',
                value: 'store_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Tipe',
                width: '150px',
                value: 'type',
                freeze: false,
                hide: false
              },
              {
                text: 'Catatan',
                width: '150px',
                value: 'note',
                freeze: false,
                hide: false
              },
            
            ]
    
            this.list = res.results.data
            this.pagination = res.results.pagination

            // Hapus markers dengan type 'visit' saja
            this.markers = this.markers.filter(marker => marker.type !== 'visit')

            // Push markers baru untuk toko yang dikunjungi
            if(this.list.length > 0) {
              this.list.map((item, index) => {
                this.markers.push({
                  label: (index+1).toString(),
                  name: item.store_name,
                  position: {lat: item.latitude*1, lng: item.longitude*1},
                  item: item,
                  index: index+1,
                  type: 'visit'
                })
              })
            }

            // this.list.map(obj => {
            //   obj.is_active = obj.is_active === 'Aktif' ? true : false
            // })

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.fetchNotVisited()


            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      async fetchNotVisited (pagination = { row: 50, page: 1 }) {
          this.process.load = true

          this.limit = pagination.row
          this.paginationList = pagination


          let params = {
            datetime: this.filterDate,
            limit: 1000000000000,
            sort: `${this.sortDesc}${this.sortBy}`,
            sales: this.sales.filter(obj => obj.id === this.filter.sales)[0].name,
            date: this.filter.date,
            // spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : this.filterDataSupervisor,
            // sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0],
            // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            search: this.search,
            // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
          }

          this.selected.row = []

          // admin/services/data
          
          await get(`admin/jadwal/data_tak_tervisit`, { params })
          .then(response => {
            let res = response.data
            
            this.process.load = false
            
            this.data_tidak_tervisit = []
            // this.pagination = {}
            
            if (res.status === 200) {
              this.headers = [
                {
                  text: '',
                  width: '120px',
                  value: 'id',
                  freeze: true,
                  hide: false,
                  align: 'start',
                  format: 'action'
                },
                {
                  text: 'No',
                  width: '80',
                  value: 'index',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Tanggal',
                  width: '200px',
                  value: 'datetime',
                  freeze: true,
                  hide: false,
                  format: 'datetime'
                },
                {
                  text: 'Nama Sales',
                  width: '300px',
                  value: 'sales_name',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'Nama Customer',
                  width: '200px',
                  value: 'customer_name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Nama Toko',
                  width: '200px',
                  value: 'store_name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Tipe',
                  width: '150px',
                  value: 'type',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Catatan',
                  width: '150px',
                  value: 'note',
                  freeze: false,
                  hide: false
                },
              
              ]
      
              this.data_tidak_tervisit = res.results.data

              // console.log(this.data_tidak_tervisit)
              // this.pagination = res.results.pagination

              // Hapus markers dengan type 'not-visit' saja
              this.markers = this.markers.filter(marker => marker.type !== 'not-visit')

              // Push markers baru untuk toko yang tidak dikunjungi
              if(this.data_tidak_tervisit.length > 0) {
                this.data_tidak_tervisit.map((item, index) => {
                  // Pastikan latitude dan longitude ada
                  if(item.store_latitude && item.store_longitude) {
                    this.markers.push({
                      label: 'X' + (index+1).toString(),
                      name: item.store_name,
                      position: {lat: item.store_latitude*1, lng: item.store_longitude*1},
                      item: {
                        ...item,
                        checkin_datetime: null,
                        checkout_datetime: null,
                        foto_bukti: '',
                        foto_bukti_2: '',
                        foto_bukti_3: '',
                        note: item.store_notes,
                        type: 'Tidak Dikunjungi'
                      },
                      index: 'X' + (index+1),
                      type: 'not-visit'
                    })
                  }
                })
              }

              // this.list.map(obj => {
              //   obj.is_active = obj.is_active === 'Aktif' ? true : false
              // })

              this.lastIndex = (pagination.page - 1) * pagination.row 
              this.lastIndex += 1


              this.addFreezes()

              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

              if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          })
        },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          name: index !== undefined ? this.list[index].name : '',
          par_id: index !== undefined ? this.list[index].par_id : '0',
          // type: index !== undefined ? this.list[index].type : "",
          // is_active: index !== undefined ? this.list[index].is_active === 'Aktif'? 1 : 0 : 1
        }

        if (index !== undefined) {
          this.detail = this.list[index]
        }

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'admin/visit/add' : 'admin/visit/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/visit/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>

<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
    /* width: 100%; */
  }

  .wrapper-detail-jadwal-visit { 
    overflow-y: auto; 
    height: calc(100vh - 310px); 
  } 

  .wrapper-detail-jadwal-visit-none { 
    /* overflow-y: auto; 
    height: calc(100vh - 270px);  */
  } 

  .wrapper-detail-jadwal-visit th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
    z-index: 1
  } 
  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }

  .one-col {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    left: 0px;
  }

  .second-col-laporan-detail-visit {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 80px;
  }

  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }

  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }

  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}
</style>